import React from 'react';

import classNames from 'classnames';

import styles from './Row.module.css';

type RowProps = {
  borderBottom?: boolean;
  children: React.ReactNode;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const Row = ({ borderBottom = false, children, className }: RowProps) => {
  const containerClass = classNames(styles.container, className, {
    [styles.borderBottom]: borderBottom,
  });

  return <div className={containerClass}>{children}</div>;
};

export default Row;
